import React from 'react';
import { KratosTokenKey } from '../core/types';
import { AccentPresentation, getKratosTokenPresentation } from '../core/utilities/token-presentation';

interface NumericFieldProps {
    label: string;
    value: number;
    onDecrement: () => void;
    onIncrement: () => void;
    tokenKey?: KratosTokenKey;
    accent?: AccentPresentation;
}

/**
 * Card-style numeric display: label + value inside a box, stacked +/- buttons on the right.
 */
const NumericField: React.FC<NumericFieldProps> = ({ label, value, onDecrement, onIncrement, tokenKey, accent }) => {
    const accentPresentation = accent ?? (tokenKey ? getKratosTokenPresentation(tokenKey) : null);
    const tokenStyle =
        accentPresentation !== null
            ? ({
                  '--token-accent-color': accentPresentation.color,
                  '--token-accent-tint': accentPresentation.tint,
              } as React.CSSProperties)
            : undefined;

    return (
        <div className={`numeric-field ${accentPresentation ? 'numeric-field-token' : ''}`} style={tokenStyle}>
            <div className="numeric-field-card">
                <span className="numeric-field-label">{label}</span>
                <span className="numeric-field-value">{value}</span>
            </div>
            <div className="numeric-field-buttons">
                <button type="button" className="numeric-field-btn" onClick={onIncrement}>
                    +
                </button>
                <button type="button" className="numeric-field-btn decrement" onClick={onDecrement}>
                    −
                </button>
            </div>
        </div>
    );
};

export default NumericField;
